<template>
  <div>
    <v-container>
      <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mt-3">
        <div class="title mb-3">จำนวนและช่องทางในการติดต่อหาช่าง</div>

        <v-layout row wrap v-if="!loading">
          <v-flex xs6 class="pr-1">
            <div>
              <v-card style="height: 150px">
                <div style="background-color: #3b5998; color: white; padding: 8px">facebook</div>
                <div class="text-xs-center">
                  <h2>{{ facebook_num }}</h2>
                </div>
              </v-card>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-1">
            <div>
              <v-card style="height: 150px">
                <div style="background-color: #00b900; color: white; padding: 8px">LINE</div>
                <div class="text-xs-center">
                  <h2>{{ line_num }}</h2>
                </div>
              </v-card>
            </div></v-flex
          >
        </v-layout>
        <div v-else>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      facebook_num: 0,
      line_num: 0,
      dealertype: {
        label: 'ช่างที่กดยืนยันรับงาน',
        value: 'painterconfirmjobdashboard'
      },
      optionType: [
        {
          label: 'ช่างที่กดยืนยันรับงาน',
          value: 'painterconfirmjobdashboard'
        },
        {
          label: 'ช่างที่ได้รับการรีวิว',
          value: 'painterreviewjobdashboard'
        },
        {
          label: 'ช่างที่กดส่งคำขอเริ่มงาน',
          value: 'paintersendstartdatejobdashboard'
        },
        {
          label: 'ช่างที่กดยกเลิกงาน',
          value: 'paintercanceledjobdashboard'
        },
        {
          label: 'ช่างที่กดอัพเดตงานลูกค้า',
          value: 'painterupdatejobdashboard'
        }
      ],
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      headers: [{ text: 'ชื่อช่าง', value: 'name', align: 'center', width: '1%' }]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    onChangeType() {},
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        this.loading = true
        api['channeltoquotationdealerdashboard'](data, (err, response) => {
          this.loading = false
          this.data = response.data

          var line = this.data.find((el) => el.app == 'line')
          var facebook = this.data.find((el) => el.app == 'facebook')
          if (line) {
            this.line_num = line.total
          } else {
            this.line_num = 0
          }
          if (facebook) {
            this.facebook_num = facebook.total
          } else {
            this.facebook_num = 0
          }

          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Dealer/channeltoquotationdealerdashboard.vue